module.exports = __webpack_public_path__ + "static/media/explore_col_1.a3208403.svg";